"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.import_icon = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const import_icon = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'import-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.25 4.4762C11.25 4.06198 11.5858 3.7262 12 3.7262H15.5C16.1904 3.7262 16.75 4.28584 16.75 4.9762V15.9762C16.75 16.6666 16.1904 17.2262 15.5 17.2262H12C11.5858 17.2262 11.25 16.8904 11.25 16.4762C11.25 16.062 11.5858 15.7262 12 15.7262H15.25V5.2262H12C11.5858 5.2262 11.25 4.89041 11.25 4.4762ZM9.01986 6.90003C9.33807 6.63486 9.81099 6.67785 10.0762 6.99606L12.5762 9.99606C12.8079 10.2742 12.8079 10.6782 12.5762 10.9563L10.0762 13.9563C9.81099 14.2745 9.33807 14.3175 9.01986 14.0524C8.70165 13.7872 8.65866 13.3143 8.92383 12.9961L10.3987 11.2262H4C3.58579 11.2262 3.25 10.8904 3.25 10.4762C3.25 10.062 3.58579 9.7262 4 9.7262H10.3987L8.92383 7.95633C8.65866 7.63813 8.70165 7.1652 9.01986 6.90003Z', fill: '#4B5563' })));
};
exports.import_icon = import_icon;
